import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { TipiUfficiContext, TipiUfficiProvider } from './TipiUfficiContext';
import { TipiList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo
    } = useContext(NavContext);

    const {

        state,
        setState,

        isLoadingTipiUffici,
        getTipiUfficiAsync,

        isDeletingTipoUfficio,
        deleteTipoUfficioAsync,

    } = useContext(TipiUfficiContext)

    const {
        deleteTipoUfficio
    } = state;

    const loadMoreHandler = async (pageIndex, pageSize, searchText) => {
        await getTipiUfficiAsync(pageIndex, pageSize, searchText);
    }

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const tipiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.TipoUfficioAdd, "_blank").focus();
                break;
            case "Delete":
                setState({ deleteTipoUfficio: data });
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingTipiUffici || isDeletingTipoUfficio);
    }, [isLoadingTipiUffici, isDeletingTipoUfficio]);

    useEffect(() => {
        if (user && deleteTipoUfficio)
            deleteTipoUfficioAsync(deleteTipoUfficio.id);
        // setOpenDeleteTipoUfficioDialog(true);
    }, [deleteTipoUfficio, user])

    useEffect(() => {
        if (user)
            addBreadcrumbToken("Ambiti");
    }, [user]);

    const [openDeleteTipoUfficioDialog, setOpenDeleteTipoUfficioDialog] = useState(false);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            search
                            onSearchClick={searchClickHandler}
                            title="Ambiti"
                            subtitle="Gestisci i ambiti" />
                    </Grid>
                    <Grid item xs={12}>
                        <TipiList
                            searchText={searchText}
                            onActionClick={tipiListActionClickHandler}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading} />
                    </Grid>
                </Grid>
            </Container>
            {/* <ActionDialog
                title="Disabilitazione competenza"
                content={`Sei sicuro di disabilitare la "${deleteTipoUfficio?.nome}"`}
                open={openDeleteTipoUfficioDialog}
                handleClose={() => {
                    setOpenDeleteTipoUfficioDialog(false);
                    setState({ deleteTipoUfficio: null });
                }}
                handleSubmit={() => {
                    deleteTipoUfficioAsync(deleteTipoUfficio.id);
                    setOpenDeleteTipoUfficioDialog(false);
                    setState({ deleteTipoUfficio: null });
                }}
            /> */}
        </>
    );
}

export const TipiUfficiPage = () => {

    return (
        <TipiUfficiProvider>
            <PageContent />
        </TipiUfficiProvider>
    );
}